import api from "../services/api";
import Cookies from "js-cookie";

const REFRESH_URL = "/user/update_token";

// A pagina publica do certificado e acessada por gente deslogada.
// Um 401/403/404 ali NUNCA deve disparar refresh nem redirecionar.
// Atencao: '/certificate/' (com barra) e a rota publica;
// '/certificateToken' e autenticada e continua passando pelo refresh.
function isPublicCertificateRequest(config) {
  const url = config && config.url ? String(config.url) : "";
  return url.indexOf("/certificate/") !== -1;
}

let isRefreshing = false;
let failedQueue = [];

function processQueue(error, token = null) {
  failedQueue.forEach((prom) => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
}

api.interceptors.request.use(function (config) {
  const token = Cookies.get("Authorization");

  // Antes: config.headers.Authorization = undefined, que o axios envia como
  // a string literal "undefined". Agora o header simplesmente nao vai.
  if (token && token !== "undefined" && token !== "null") {
    config.headers.Authorization = token;
  } else if (config.headers) {
    delete config.headers.Authorization;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (err) => {
    const originalRequest = err.config;

    // err.response e undefined em erro de rede / CORS / timeout.
    if (!err.response || !originalRequest) {
      return Promise.reject(err);
    }

    if (err.response.status !== 401) {
      return Promise.reject(err);
    }

    // Nao tentar refresh: pagina publica, a propria rota de refresh,
    // ou requisicao ja repetida uma vez.
    if (
      isPublicCertificateRequest(originalRequest) ||
      String(originalRequest.url || "").indexOf(REFRESH_URL) !== -1 ||
      originalRequest._retry
    ) {
      return Promise.reject(err);
    }

    // Sem refreshToken nao ha o que renovar.
    const refreshToken = Cookies.get("refreshToken");
    if (!refreshToken || refreshToken === "undefined") {
      return Promise.reject(err);
    }

    if (isRefreshing) {
      return new Promise(function (resolve, reject) {
        failedQueue.push({ resolve, reject });
      }).then((token) => {
        originalRequest.headers["Authorization"] = "Bearer " + token;
        return api(originalRequest);
      });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    return new Promise(function (resolve, reject) {
      // Usa o baseURL do proprio api. Antes montava
      // process.env.REACT_APP_API_URL + ..., e essa variavel esta indefinida
      // (a linha correspondente em services/api.js esta comentada),
      // resultando em "undefined/user/update_token".
      api
        .post(REFRESH_URL, { refreshToken })
        .then((data) => {
          const newAuth = data.headers.authorization;

          // Se o backend nao expuser o header via Access-Control-Expose-Headers,
          // newAuth vem undefined. Gravar isso no cookie era a origem do
          // travamento em tela branca.
          if (!newAuth) {
            const error = new Error(
              "Refresh sem header Authorization na resposta.",
            );
            processQueue(error, null);
            reject(error);
            return;
          }

          Cookies.set("Authorization", newAuth);
          if (data.data && data.data.refreshToken) {
            Cookies.set("refreshToken", data.data.refreshToken);
          }

          api.defaults.headers.common["Authorization"] = newAuth;
          originalRequest.headers["Authorization"] = newAuth;

          processQueue(null, newAuth);
          resolve(api(originalRequest));
        })
        .catch((error) => {
          processQueue(error, null);
          reject(error);
        })
        .then(() => {
          isRefreshing = false;
        });
    });
  },
);
